import React, { useState } from "react";
import axios from "axios";

export default function GeneralEndpoints() {
  const [dashboardData, setDashboardData] = useState(null);
  const [feedbackData, setFeedbackData] = useState({});
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [rubricData, setRubricData] = useState(null);

  // Fetch Dashboard Statistics
  const fetchDashboardStatistics = async () => {
    try {
      const response = await axios.get("/api/dashboard/");
      setDashboardData(response.data);
    } catch (error) {
      console.error("Error fetching dashboard statistics:", error);
    }
  };

  // Generate PDF
  const handleGeneratePDF = async () => {
    try {
      const response = await axios.post("/api/generatepdf", {
        feedback_data: feedbackData,
      });
      console.log("PDF Generation Payload:", response.data.payload);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  // Change Password
  const handleChangePassword = async (isTeacher) => {
    try {
      const response = await axios.post("/api/changepassword/", {
        username,
        new_password: newPassword,
        teacher: isTeacher,
        student: !isTeacher,
      });
      const data = response.data;
      if (data.status === "success") {
        console.log("Password changed successfully:", data);
      } else {
        console.error("Error changing password:", data.message);
      }
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  // Get Rubric
  const handleGetRubric = async (typeofreq, id, changejson = null) => {
    try {
      const requestBody = { typeofreq, id };
      if (changejson) {
        requestBody.changejson = changejson;
      }

      const response = await axios.post("/api/getrubric/", requestBody);
      setRubricData(response.data);
    } catch (error) {
      console.error("Error fetching rubric:", error);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2>General API Testing Interface</h2>

      {/* Dashboard Statistics */}
      <div style={{ marginBottom: "20px" }}>
        <button onClick={fetchDashboardStatistics} style={buttonStyle}>
          Fetch Dashboard Statistics
        </button>
        {dashboardData && (
          <pre style={preStyle}>{JSON.stringify(dashboardData, null, 2)}</pre>
        )}
      </div>

      {/* Generate PDF */}
      <div style={{ marginBottom: "20px" }}>
        <h4>Generate PDF</h4>
        <textarea
          placeholder="Enter feedback data"
          value={JSON.stringify(feedbackData)}
          onChange={(e) => setFeedbackData(JSON.parse(e.target.value))}
          style={textareaStyle}
        />
        <button onClick={handleGeneratePDF} style={buttonStyle}>
          Generate PDF
        </button>
      </div>

      {/* Change Password */}
      <div style={{ marginBottom: "20px" }}>
        <h4>Change Password</h4>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          style={inputStyle}
        />
        <button onClick={() => handleChangePassword(true)} style={buttonStyle}>
          Change Teacher Password
        </button>
        <button onClick={() => handleChangePassword(false)} style={buttonStyle}>
          Change Student Password
        </button>
      </div>

      {/* Get Rubric */}
      <div style={{ marginBottom: "20px" }}>
        <h4>Get Rubric</h4>
        <button
          onClick={() => handleGetRubric("teacher", 1)}
          style={buttonStyle}
        >
          Get Teacher Rubric
        </button>
        <button
          onClick={() => handleGetRubric("student", 1)}
          style={buttonStyle}
        >
          Get Student Rubric
        </button>
        {rubricData && (
          <pre style={preStyle}>{JSON.stringify(rubricData, null, 2)}</pre>
        )}
      </div>
    </div>
  );
}

const buttonStyle = {
  padding: "10px 20px",
  margin: "5px",
  borderRadius: "4px",
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  cursor: "pointer",
};

const inputStyle = {
  padding: "5px",
  margin: "5px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  width: "200px",
};

const textareaStyle = {
  padding: "5px",
  margin: "5px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  width: "300px",
  height: "100px",
};

const preStyle = {
  backgroundColor: "#f4f4f4",
  padding: "10px",
  borderRadius: "4px",
  overflowX: "auto",
};
